import nlnAxios from "../../../api/nlnAxios";


//Get Landingpage
const getLandingPage = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
            
    }
}

    const response = await nlnAxios.get("/library/public/home");

    return response.data;
}



const landingPageService = {
    getLandingPage
    
}

export default landingPageService;